import React, { useState } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import GnomadGenesV4 from "./GnomadGenesV4";
import GnomadGenesV2 from "./GnomadGenesV2";
import withErrorGuard from "../../../../HOC/withErrorGuard";

function GnomadGenes({ data }) {
  const [selectedItem, setSelectedItem] = useState(data?.items?.[0]);
  const isV2 = data?.version === "2.1";

  return !data || !data?.items?.length ? null : (
    <div className="varsome-result-fixed" data-testid="gnomad-genes-component">
      <div className="varsome-container varsome-container__basic">
        <ComponentPanel
          title="GnomAD Genes"
          version={data?.version}
          url={getVarsoUrl("http://gnomad.broadinstitute.org/")}
          titleDetailsRight={
            isV2 || !data.ensembl_gene_id ? null : (
              <div className="tw-inline-flex tw-items-center tw-float-right">
                <span className="tw-mr-3">
                  <a
                    href={getVarsoUrl(
                      `https://gnomad.broadinstitute.org/gene/${data.ensembl_gene_id}?dataset=gnomad_r4`
                    )}
                    target="_blank"
                  >
                    View full records on gnomAD
                  </a>
                </span>
              </div>
            )
          }
          content={
            <div className="varsome-inner-container">
              {data?.items?.length > 1 ? (
                <div className="tw-mt-6 tw-mb-12 tw-flex tw-flex-col tw-items-center tw-justify-items-center">
                  <div className="tw-font-bold tw-text-xs">
                    Select transcript
                  </div>
                  <div className="tw-w-64">
                    <Select
                      value={selectedItem}
                      options={data.items}
                      isSearchable={false}
                      getOptionLabel={(item) => item.transcript}
                      getOptionValue={(item) => item.transcript}
                      onChange={(item) => setSelectedItem(item)}
                    />
                  </div>
                </div>
              ) : null}
              {isV2 ? (
                <GnomadGenesV2 gnomadEntry={selectedItem} />
              ) : (
                <GnomadGenesV4
                  gnomadEntry={selectedItem}
                  geneSymbol={data.gene}
                />
              )}
            </div>
          }
        />
      </div>
    </div>
  );
}

GnomadGenes.propTypes = {
  data: PropTypes.shape({
    version: PropTypes.string,
    ensembl_gene_id: PropTypes.string,
    gene: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({ transcript: PropTypes.string })),
  }),
};

GnomadGenes.defaultProps = {
  data: {
    version: "",
    items: [],
  },
};

export default withErrorGuard(GnomadGenes, "gnomadGenes", "GnomAD Genes");
